import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import LoadingWrapper from 'components/Common/LoadingWrapper';
import ImyFormTable from 'components/ImyFormTable';
import ModalWrapper from '../ModalWrapper';

class CustomerImyFormsModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    isShown: PropTypes.bool.isRequired,
    isGettingParentImyForms: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    parentImyForms: PropTypes.shape()
  };

  static defaultProps = {
    isGettingParentImyForms: false,
    parentImyForms: null
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.isShown && nextProps.parentImyForms?.imyforms?.length === 1) {
      this.navigateToImyStructure(nextProps?.parentImyForms.imyforms[0]);
      return false;
    }

    return true;
  }

  navigateToImyStructure(form) {
    const { dispatch } = this.props;

    dispatch(push(`/w8imystructure/${ form.topLevelAccountId }`));
    this.closeModal();
  }

  closeModal() {
    const { onClose } = this.props;
    onClose();
  }

  render() {
    const {
      isShown,
      isGettingParentImyForms,
      parentImyForms,
      dispatch
    } = this.props;

    return (
      <ModalWrapper
        isOpen={ isShown }
        title="IMY Trees"
        btnCancelTitle="Close"
        onCancel={ e => this.closeModal() }
        showFooter={ false }
        modalSize="modal-lg whd-rates-modal"
      >
        { isGettingParentImyForms && <LoadingWrapper loaded={ !isGettingParentImyForms } message="Fetching IMY Structure details" /> }
        { !isGettingParentImyForms && parentImyForms && <div>
          <ImyFormTable ImyForms={ parentImyForms } isGettingImyForms={ isGettingParentImyForms } dispatch={ dispatch } />
          </div> }
      </ModalWrapper>
    );
  }
}

function mapStateToProps(state) {
  const { forms: {
    isGettingParentImyForms,
    parentImyForms
  } } = state;

  return {
    isGettingParentImyForms,
    parentImyForms
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerImyFormsModal);
